module.exports = __webpack_public_path__ + "img/ZWF_Christopher_Hauff.ec662f2c.jpg";